import React,{useEffect} from 'react'

const TermsAndConditions = () => {
    useEffect(() =>{
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth'})
    },[])
  return (
    <div className='d-flex justify-content-center align-items-center mt-2'>
      <div className='terms'>
           <h2 className='d-flex justify-content-center align-items-center'>Terms and Conditions</h2>
           <div>
              Welcome to <strong>Nexonweb Solution!</strong> By accessing and using our website and services, you agree to comply with the terms and conditions outlined below. Please read these Terms and Conditions carefully. If you do not agree with any part of these terms, you must refrain from using our services.
           </div>

           <h4>1. Definitions</h4>

           <ul>
             <li><strong>"Company"</strong> refers to <strong>Nexonweb Solution</strong>, its employees, affiliates, and subsidiaries.</li>
             <li><strong>"User"</strong> refers to any individual or entity using our website or services.</li>
             <li><strong>"Services"</strong> refer to all products, solutions, and resources offered by Nexonweb Solution.</li>
             <li><strong>"Website"</strong>refers to <a href='https://www.nexonweb.com/index'>www.nexonweb.com</a></li>
           </ul>

           <h4>2. Eligibility</h4>
           <p>To use our services, you must:</p>
           <ol>
             <li>Be at least 18 years old or of legal age as per the laws of your jurisdiction.</li>
             <li>Have the authority to enter into a legally binding agreement.</li>
             <li>Provide accurate and complete information during the registration process.</li>
           </ol>


           <h4>3. Scope of Services</h4>
           <p>Nexonweb Solution offers IT services, including but not limited to:</p>
           <ul>
              <li>Web design and development.</li>
              <li>Software development.</li>
              <li>Digital marketing services.</li>
              <li>Cloud and hosting solutions.</li>
           </ul>
           <p>The specific scope of services provided will be detailed in agreements or contracts signed with the User.</p>

           <h4>4. User Obligations</h4>
           <p>By using our services, you agree to:</p>
           <ol>
             <li>Provide accurate, complete, and up-to-date information as required.</li>
             <li>Maintain the confidentiality of login credentials and notify us immediately of any unauthorized use.</li>
             <li>Comply with all applicable laws, regulations, and our policies.</li>
             <li>Avoid engaging in activities that may:</li>
             <ul>
                <li>Disrupt the operation of our website or services.</li>
                <li>Violate intellectual property rights of the Company or third parties.</li>
                <li>oIntroduce viruses, malware, or other harmful code.</li>
             </ul>
           </ol>
           <p>Failure to adhere to these obligations may result in suspension or termination of access to our services.</p>


           <h4>5. Fees and Payment</h4>
           <ol>
             <li><strong>Service Fees: </strong>Users agree to pay all fees associated with the services as specified in the contract or invoice.</li>
             <li><strong>Payment Methods:</strong> Payments can be made via approved methods, including online payment gateways, bank transfers, or other means agreed upon.</li>
             <li><strong>Refunds: </strong>Refund policies, if any, will be outlined in specific agreements or service contracts.</li>
           </ol>

           <h4>6. Intellectual Property</h4>
           <ol>
             <li><strong>Ownership:</strong> All content, trademarks, logos, designs, and software developed by or for Nexonweb Solution are the property of the Company unless otherwise specified.</li>
             <li><strong>Usage Rights:</strong> Users may not reproduce, distribute, or modify any content or intellectual property of the Company without prior written permission.</li>
             <li><strong>User Content: </strong>Users retain ownership of any data or materials provided to the Company but grant us a non-exclusive license to use such content for providing services.</li>
           </ol>


           <h4>7. Confidentiality</h4>
           <p>Both the Company and Users agree to maintain the confidentiality of all proprietary or sensitive information shared during the course of their relationship. Such information will not be disclosed to third parties without prior written consent unless required by law.</p>


           <h4>8. Limitation of Liability</h4>
           <p>To the extent permitted by law:</p>
           <ol>
             <li>Nexonweb Solution shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services.</li>
             <li>Our total liability for any claim arising from the use of our services shall not exceed the amount paid by the User for the service in question.</li>
           </ol>


           <h4>9. Termination</h4>
           <ol>
             <li>Users may terminate their account or cease using the services at any time by providing written notice.</li>
             <li>The Company reserves the right to suspend or terminate access to services if:</li>
             <ul>
                <li>A User breaches these Terms and Conditions.</li>
                <li>Payment obligations are not met.</li>
                <li>Fraudulent or unauthorized activity is detected.</li>
             </ul>
           </ol>
           <p>Upon termination, any outstanding dues must be cleared, and access to services may be revoked.</p>

           <h4>10. Indenity</h4>
           <p>Users agree to indemnify and hold Nexonweb Solution harmless from any claims, losses, damages, liabilities, or expenses arising from:</p>
           <ol>
             <li>Violation of these Terms and Conditions.</li>
             <li>Unauthorized use of our services.</li>
             <li>Breach of any applicable laws or regulations.</li>
           </ol>

           <h4>11. Force Majeure</h4>
           <p>Nexonweb Solution shall not be liable for any failure or delay in providing services due to events beyond its reasonable control, including but not limited to natural disasters, acts of government, war, cyber-attacks, or labor disputes.</p>

   

           <h4>12. Governing Law and Jurisdiction</h4>
           <p>These Terms and Conditions shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in [Insert Location].</p>


           <h4>13. Amendments</h4>
           <p>Nexonweb Solution reserves the right to update or modify these Terms and Conditions at any time. Users will be notified of significant changes via email or updates on our website. Continued use of our services after changes implies acceptance of the updated Terms.</p>


           <h4>14. Contact Information</h4>
           <p>For questions, concerns, or disputes related to these Terms and Conditions, you may contact us at:</p>
           <p>Email: info@nexonweb.com</p>
           <p>Phone: +91-906363-0795</p>
      </div>
    </div>
  )
}

export default TermsAndConditions
